module.exports = __webpack_public_path__ + "img/jujialei-5.f3f26f11.png";